import React from 'react';
import PropTypes from 'prop-types';
import { HtmlRaw, Text } from '../../../atoms';
import { TimeCard, Timebar, TimelineContainer } from './style';
import CustomScrollbar from '../../../atoms/CustomScrollbar';

const Timeline = ({ data, title }) => {
  return (
    <>
      <Text type="h2">{title}</Text>
      <Timebar />
      {data?.length > 0 && (
        <CustomScrollbar>
          <TimelineContainer>
            {data.map(({ data: item }, i) => (
              <TimeCard key={`item-${i}`}>
                <div className="time-dot" />
                <Text type="h2" mb={16}>
                  {item?.date}
                </Text>
                <Text type="h3" mb={8}>
                  {item?.title}
                </Text>
                <Text type="b3" mb={24}>
                  <HtmlRaw html={item?.description} />
                </Text>
              </TimeCard>
            ))}
          </TimelineContainer>
        </CustomScrollbar>
      )}
    </>
  );
};

Timeline.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};

export default Timeline;
